import React, { useEffect, useState } from 'react';
import { useFormik, FormikProvider, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import * as bie from "react-bootstrap";
import Swal from 'sweetalert2';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';

export default function CorpusApplication({ paymentDone, goNext }) {
    const [clgdata, setClgdata] = useState({});
    const [landDtls, setlandDtls] = useState([]);
    useEffect(() => {
        CommonAxiosGet(`${config.url.FAC_URL}getInstitutionPolyDetails`).then((res) => {
            const data = res?.data?.data?.[0] || {};
            setClgdata(data);
        });


        CommonAxiosGet(`${config.url.FAC_URL}getSHiftingDetails`).then((res) => {
            const data = res?.data?.data?.[0] || {};
            setlandDtls(data);
        });

    }, []);

    const InstitutionFormik = useFormik({
        initialValues: {
            planApproved: clgdata?.plan_approved || '',
            leaseAgreement: clgdata?.lease_agreement || '',
            buildOwnLease: clgdata?.buildOwnLease || '',
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            planApproved: Yup.string().required(ERROR_MSG),
            leaseAgreement: Yup.string().required(ERROR_MSG),
        }),
        onSubmit: (val) => {
            console.log("DSsdsdd", val)
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.FAC_URL + `updatePlanApproved  `
                    CommonAxiosPost(url, val).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            goNext();

                        }
                        else if (res?.data?.scode === '02') {
                            Swal.fire(res?.data?.sdesc, '', 'error').then((res) => {
                            })
                        }
                        else {
                            failureAlert("Failed to submit")

                        }
                    })
                }
            });
        }
    });

    const yearsCompleted = clgdata?.year_of_establishment
        ? new Date().getFullYear() - Number(clgdata.year_of_establishment)
        : '--';

    const tableStyle = { width: '100%', borderCollapse: 'collapse', fontSize: '14px' };

    const cellLabelStyle = {
        padding: '12px 16px',
        border: '1px solid #e2e8f0',
        color: '#444',
        verticalAlign: 'middle',
        width: '35%',
        background: '#fafbff',
    };

    const cellValueStyle = {
        padding: '12px 16px',
        border: '1px solid #e2e8f0',
        color: '#1a1a2e',
        fontWeight: '600',
        verticalAlign: 'middle',
        width: '15%',
        background: '#fff',
    };

    const sectionHeadingStyle = {
        fontWeight: '700',
        fontSize: '14px',
        color: '#1a1a2e',
        padding: '10px 16px',
        background: '#f0f4ff',
        borderTop: '1px solid #e2e8f0',
        borderBottom: '1px solid #e2e8f0',
    };




    const [eopApplication, seteopApplication] = useState([]);
    function GetEopData() {
        let url = `${config.url.FAC_URL}getEopApplication`;

        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                const data = res.data.data || [];
                seteopApplication(data);

                if (data.length > 0 && data !== "No data found") {
                    const eop = data[0];

                    InstitutionFormik.setFieldValue("planApproved", eop?.plan_approved || "");
                    InstitutionFormik.setFieldValue("leaseAgreement", eop?.leaseagreement || "");

                }
            } else {
                seteopApplication([]);
            }
        });
    }

    useEffect(() => {

        GetEopData();

    }, [])
    console.log("eopApplication", eopApplication)
    return (
        <div style={{ padding: '30px 40px', width: '100%', fontFamily: 'Arial, sans-serif' }}>
            <FormikProvider value={InstitutionFormik}>
                <Form>

                    {/* ── SINGLE WHITE CARD ── */}
                    <div style={{
                        background: '#fff',
                        borderRadius: '10px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                        overflow: 'hidden',
                        marginBottom: '24px',
                    }}>
                        <table style={tableStyle} role="presentation">
                            <tbody>

                                {/* ── Section 2 Heading ── */}
                                <tr>
                                    <td colSpan={4} style={sectionHeadingStyle}>
                                        Details of the  Land
                                    </td>
                                </tr>

                                <tr>
                                    <td style={cellLabelStyle}>
                                        Whether the society has own land as per norms
                                    </td>
                                    <td style={cellValueStyle}> Own
                                        {/* {landDtls?.build_own_lease || '--'} */}
                                    </td>
                                    <td style={cellLabelStyle}>
                                        Extent of land owned by the Society
                                    </td>
                                    <td style={cellValueStyle}>{landDtls?.extendland || '--'}</td>
                                </tr>

                                {/* Row 2.4 + 2.6 */}
                                <tr>
                                    <td style={cellLabelStyle}>
                                        Name of the Mandal in which the land is registered
                                    </td>
                                    <td style={cellValueStyle}>{landDtls?.mandal_name || '--'}</td>
                                    <td style={cellLabelStyle}>
                                        Distance of the land from the college building (in km)
                                    </td>
                                    <td style={cellValueStyle}>{landDtls?.distance || '--'}</td>
                                </tr>

                                {/* ── Section 3 Heading ── */}
                                <tr>
                                    <td colSpan={4} style={{ ...sectionHeadingStyle, borderTop: '2px solid #d0d9f0' }}>
                                        Details of Leased Building Accommodation
                                    </td>
                                </tr>

                                {/* Row 3.2 + 3.5 */}
                                <tr colSpan={2}>
                                    <td style={cellLabelStyle}>
                                        Year of Establishment of the college
                                    </td>
                                    <td style={cellValueStyle}>{clgdata?.year_of_establishment || '--'}</td>
                                    <td style={cellLabelStyle}>
                                        Total no. of years completed in leased building from the establishment
                                    </td>
                                    <td style={cellValueStyle}>{yearsCompleted}</td>
                                </tr>
                                <tr>
                                    <td style={cellLabelStyle}>
                                        Type of College Accommodation:

                                    </td>
                                    {/* 
                                    <td style={cellValueStyle} colSpan="3">
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                            <Field
                                                as="select"
                                                name="buildOwnLease"
                                                className="form-control"
                                                
                                            >
                                                <option value="">--Select--</option>
                                                <option value="false">Leased</option>
                                                <option value="true">Own</option>
                                            </Field>
                                        </div>

                                        <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                            <ErrorMessage name="buildOwnLease" />
                                        </div>
                                    </td> */}
                                    <td style={cellValueStyle}>{landDtls?.build_own_lease}</td>

                                </tr>
                                <tr>




                                    <td style={cellLabelStyle}>
                                        Whether the plan of the building accommodation is approved by competent authority
                                    </td>
                                    <td style={cellValueStyle}>
                                        <div style={{ display: 'flex', gap: '16px' }}>
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer', fontWeight: 'normal' }}>
                                                <Field type="radio" name="planApproved" value="Yes" /> Yes
                                            </label>
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer', fontWeight: 'normal' }}>
                                                <Field type="radio" name="planApproved" value="No" /> No
                                            </label>
                                        </div>
                                        <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                            <ErrorMessage name="planApproved" />
                                        </div>
                                    </td>
                                    <td style={cellLabelStyle}>
                                        Do you have 30 years of Lease  Agreement for the Building
                                    </td>
                                    <td style={cellValueStyle}>
                                        <div style={{ display: 'flex', gap: '16px' }}>
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer', fontWeight: 'normal' }}>
                                                <Field type="radio" name="leaseAgreement" value="Yes" /> Yes
                                            </label>
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer', fontWeight: 'normal' }}>
                                                <Field type="radio" name="leaseAgreement" value="No" /> No
                                            </label>
                                        </div>
                                        <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                            <ErrorMessage name="leaseAgreement" />
                                        </div>
                                    </td>

                                </tr>


                            </tbody>
                        </table>

                        <div className="d-flex justify-content-end pb-3 pt-4"  >
                            {paymentDone ? (
                                <div style={{ color: "green", fontWeight: "bold" }}>
                                    ✅ Already submitted
                                </div>
                            ) : (
                                <button
                                    type="submit"
                                    className="btn btn-success btn-sm"
                                >
                                    Submit
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Save Button */}
                    {/* <bie.Row className="mt-2">
                        <bie.Col className="text-end">
                            <button type="submit" className="btn btn-primary px-4">
                                Submit
                            </button>
                        </bie.Col>
                    </bie.Row> */}




                </Form>
            </FormikProvider>
        </div >
    );
}